
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useSampleProject = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [currentStep, setCurrentStep] = useState<string | null>(null);

  const createSampleProject = async (userId: string, onProjectCreated?: (project: any) => void): Promise<string | null> => {
    setIsCreating(true);
    
    try {
      setCurrentStep("Skapar projekt...");
      
      // Skapa exempelprojektet
      const { data: project, error: projectError } = await supabase
        .from('projects')
        .insert({
          name: 'Mitt första byggprojekt',
          description: 'Ett exempelprojekt för att utforska Arbetsmiljökontrollen',
          user_id: userId
        })
        .select()
        .single();

      if (projectError) throw projectError;

      // Optimistisk uppdatering - visa projektet direkt i UI
      if (onProjectCreated) {
        onProjectCreated(project);
      }

      setCurrentStep("Skapar mappar...");
      
      // Skapa alla mappar samtidigt med batch-insert
      const sampleFolders = [
        {
          name: 'Planering och Projektering',
          description: 'Mappar för projekterings- och planeringsfasen',
          project_id: project.id,
          created_by: userId
        },
        {
          name: 'Byggarbetsplatsen',
          description: 'Mappar för byggfasen och arbetsmiljöåtgärder',
          project_id: project.id,
          created_by: userId
        },
        {
          name: 'Egenkontroller',
          description: 'Mappar för olika typer av egenkontroller',
          project_id: project.id,
          created_by: userId
        }
      ];

      // Batch-insert alla mappar samtidigt
      const { error: foldersError } = await supabase
        .from('folders')
        .insert(sampleFolders);

      if (foldersError) {
        console.warn('Failed to create some folders:', foldersError);
        // Fortsätt ändå eftersom projektet är skapat
      }

      toast.success("Exempelprojekt skapat!", {
        description: "Du kan nu utforska funktionerna med färdiga mappar och strukturer.",
        duration: 3000 // Kortare duration för snabbare UX
      });

      return project.id;
    } catch (error: any) {
      console.error("Error creating sample project:", error);
      toast.error("Kunde inte skapa exempelprojekt", {
        description: error.message || "Ett oväntat fel uppstod",
        duration: 5000
      });
      return null;
    } finally {
      setIsCreating(false);
      setCurrentStep(null);
    }
  };

  return {
    createSampleProject,
    isCreating,
    currentStep
  };
};
